module.exports = __webpack_public_path__ + "static/img/ios_ko.3f2151ac.png";